// extracted by mini-css-extract-plugin
module.exports = {"root":"EditVenueBedroomsPanel_root__fEx8L","form":"EditVenueBedroomsPanel_form__12sWF","priceHint":"EditVenueBedroomsPanel_priceHint__Y8a6c"};